import type { MealType } from '@/types/journal-api';

/**
 * The meal type a meal eaten at `time` (local "HH:MM") most likely is, so the
 * meal form opens with one chosen (#376): breakfast before 11:00, lunch from
 * 11:00, a snack from 15:00 and dinner from 17:00. Unreadable text falls back
 * to a snack, the type that fits any hour.
 */
export function mealTypeForTime(time: string): MealType {
    const match = /^(\d{1,2}):(\d{2})/.exec(time.trim());
    if (!match) return 'SNACK';
    const minutes = Number(match[1]) * 60 + Number(match[2]);
    if (minutes < 11 * 60) return 'BREAKFAST';
    if (minutes < 15 * 60) return 'LUNCH';
    if (minutes < 17 * 60) return 'SNACK';
    return 'DINNER';
}

/** The local wall-clock time of `date` as "HH:MM", what a time input holds. */
export function timeOfDay(date: Date = new Date()): string {
    return date.toTimeString().slice(0, 5);
}
